// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import fastClick from 'fastclick'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'babel-polyfill'
// import BaiduMap from 'vue-baidu-map'
import echarts from 'echarts'
import store from './store'
// import '../src/utils/rem'
// import '../src/utils/util.js'

import Vant from 'vant'
import 'vant/lib/index.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

/* eslint-disable no-unused-vars */
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import 'styles/reset.css'
import 'styles/border.css'
import 'styles/iconfont.css'
import 'swiper/dist/css/swiper.css'
import axios from 'axios'
import filters from './filters'
// 手机端查看打印日志工具
// import vConsole from '../src/utils/vconsole'
import './permission'
import { ygkbJumpUrl, ygkbDandianJumpUrl } from '@/utils/request'

Vue.config.productionTip = false
fastClick.attach(document.body)

Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios
Vue.prototype.ygkbJumpUrl = ygkbJumpUrl
Vue.prototype.ygkbDandianJumpUrl = ygkbDandianJumpUrl
// Vue.prototype.$url = 'http://10.5.102.6:8080'
// Vue.prototype.$url = 'http://10.5.103.91:8080'
// Vue.prototype.$url = 'http://47.105.191.13'
// Vue.prototype.$url = 'http://10.5.75.111:8080'
// Vue.prototype.$url = 'http://10.5.75.27:8080'
// Vue.prototype.$url = 'http://10.5.75.66:9082'
// Vue.prototype.$url = 'http://10.5.75.54:8080'

// Vue.prototype.$url = 'http://10.5.75.27:8080/simpapp/'
Vue.use(VueAwesomeSwiper)
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

// Vue.use(BaiduMap, {
//   ak: 'http://api.map.baidu.com/api?v=2.0&ak=lBfbEOZUyL4eQeEZ4tPmn077ckU0Gq8i'
// })

Vue.use(Vant)

Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})

// router.beforeEach((to, from, next) => {
//   document.title = store.state.entirety.title
//   next()
// })



// WEBPACK FOOTER //
// ./src/main.js